export const globalParams = {
    autoLogoutTime: 60 * 60 * 1000,
};
export default globalParams;
